// extracted by mini-css-extract-plugin
export default {"container":"Error_container__cRMi1","heading":"Error_heading__h3ikN","message":"Error_message__QF+Aq","no_data_img":"Error_no_data_img__dodM5"};